export const Navbar = ({ activeRoute, lastCode, onNavigate }) => {
  const lastCodeText = lastCode ? `Last Code: ${lastCode}` : 'Your last generated code will show up here';

  return (
    <nav className="navbar navbar-expand-lg p-0">
      <div className="container-fluid p-0">
        <div className="row m-0">
          <div className="col-2 bg-green text-start" />
          <div className="col-8 bg-green text-center align-content-center">
            <p id="lastCode" className="m-0 py-2 above-top">{lastCodeText}</p>
          </div>
          <div className="col-2 bg-green text-end align-content-center">
            <p className="m-0 py-1">
              <button
                id="copy-top"
                className="bg-green btn p-0"
                type="button"
                aria-label="Copy last code"
                disabled={!lastCode}
                onClick={() => navigator.clipboard.writeText(lastCode || '')}
              >
                <i className="bi bi-copy" />
              </button>
            </p>
          </div>
          <div className="ps-3 py-2 col-9 col-sm-6 col-md-4 col-lg-3 top align-content-center">
            <button className="navbar-brand border-0 bg-transparent p-0" type="button" onClick={() => onNavigate('upload')}>
              <img alt="logo" src="./logo.png" />
            </button>
          </div>
          <div className="pe-3 col-3 col-sm-6 col-md-8 col-lg-9 text-end top d-flex align-items-center justify-content-end">
            <button
              className="navbar-toggler collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar"
              aria-controls="navbar"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="toggler-icon top-bar" />
              <span className="toggler-icon middle-bar" />
              <span className="toggler-icon bottom-bar" />
            </button>
          </div>
          <div className="col-12 py-1 collapse navbar-collapse bottom" id="navbar">
            <ul className="navbar-nav mx-auto my-2 my-lg-0">
              <li className="nav-item">
                <button
                  className={activeRoute === 'upload' ? 'nav-link active btn btn-link' : 'nav-link btn btn-link'}
                  type="button"
                  onClick={() => onNavigate('upload')}
                >
                  Upload
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={activeRoute === 'privacy' ? 'nav-link active btn btn-link' : 'nav-link btn btn-link'}
                  type="button"
                  onClick={() => onNavigate('privacy')}
                >
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

